import React, { useState } from "react";
import PropTypes from "prop-types";
import CircularProgress from "@mui/material/CircularProgress";
import FacebookIcon from "@mui/icons-material/Facebook";
import Button from "@mui/material/Button";
import { useMediaQuery } from "@mui/material";
import { fetchHandleError } from "../../helpers/fetchHandleError";
import { useNotify } from "react-admin";

const facebookColor = { backgroundColor: "#4267B2" };

const SocialLink = ({ provider, showPersonalLogin = true }) => {
  const notify = useNotify();
  const [disable, setDisable] = useState(false);
  const isSmall = useMediaQuery((theme) => theme.breakpoints.down("md"));

  return (
    <>
      {showPersonalLogin && (
        <a
          href={`${process.env.REACT_APP_FB_LOGIN_CMS_HOST}/connect/${provider}`}
          className="link"
        >
          <Button
            style={facebookColor}
            disabled={disable}
            onClick={() => {
              setDisable(true);
            }}
            startIcon={
              disable ? <CircularProgress size={14} /> : <FacebookIcon />
            }
            fullWidth
            edge="start"
            variant="contained"
          >
            Login with Facebook
          </Button>
        </a>
      )}
      <br />
      <br />

      {!isSmall && (
        <Button
          style={facebookColor}
          onClick={() => {
            window.FB.login(
              function (response) {
                if (response.status === "connected") {
                  // Logged into your webpage and Facebook.
                  fetch(
                    `${process.env.REACT_APP_FB_LOGIN_CMS_HOST}/pages/exchange-code/${response.authResponse.code}`
                  )
                    .then(fetchHandleError)
                    .then((response) => {
                      window.location.replace(
                        `/#/auth/facebook/callback?access_token=${response.access_token}`
                      );
                    })
                    .catch((e) => {
                      notify(e.message, { type: "error" });
                    });
                } else {
                  // The person is not logged into your webpage or we are unable to tell.
                }
              },
              {
                config_id:
                  process.env.REACT_APP_FACEBOOK_BUSINESS_LOGIN_CONFIG_ID,
                response_type: "code",
                override_default_response_type: true,
              }
            );
          }}
          startIcon={<FacebookIcon />}
          fullWidth
          edge="start"
          variant="contained"
        >
          Login with Facebook for Business
        </Button>
      )}

      {/* {!isSmall && (
        <Button
          style={facebookColor}
          disabled={disable}
          onClick={() => {
            window.location.replace(
              `https://www.facebook.com/dialog/oauth?client_id=3628550937390028&response_type=code&redirect_uri=https%3A%2F%2Ffb-live-api.boxify.io%2Fconnect%2Ffacebook%2Fcallback&config_id=843876834413861`
            );
            setDisable(true);
          }}
          startIcon={
            disable ? <CircularProgress size={14} /> : <FacebookIcon />
          }
          fullWidth
          edge="start"
          variant="contained"
        >
          Login with Facebook for Business
        </Button>
      )} */}
      {/* </a> */}
      {/* <p>We'll never post anything without your permission.</p> */}
    </>
  );
};

SocialLink.propTypes = {
  provider: PropTypes.string.isRequired,
};

export default SocialLink;
